import { render, staticRenderFns } from "./rental-list.vue?vue&type=template&id=58c1aff1&scoped=true&"
import script from "./rental-list.vue?vue&type=script&lang=js&"
export * from "./rental-list.vue?vue&type=script&lang=js&"
import style0 from "./rental-list.vue?vue&type=style&index=0&id=58c1aff1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c1aff1",
  null
  
)

export default component.exports